export const tr = {
    'exclude-phrases': 'Sıfır göstergeli sözcük gruplarını hariç tut'
};
